import {assert} from 'assert-ts';
import type {LinkedValueSearchFieldConfig} from 'feature/linkedValueSearch/types';
import type {LinkedValueLink} from 'schemaDefinition/types';
import {isVerifiedLinkedCatalogPostLink} from 'schemaDefinition/functions/isVerifiedLinkedCatalogPostLink';
import type {CoreSearchState} from '../types';
import {DefaultMainEntity, EntitySearchState} from '../types';
import {getDefaultSubEntity} from './getDefaultSubEntity';
import {getSearchString} from './getSearchString';

const defaultState: CoreSearchState = {
  state: EntitySearchState.search,
  searchQuery: '',
  selectedMainEntity: DefaultMainEntity,
  includeHachetteWorks: false,
};

export const makeInitialSearchState = (
  currentSourceValue: LinkedValueLink | undefined,
  currentSourceConfig: LinkedValueSearchFieldConfig | undefined,
  includeHachetteWorks?: boolean,
): CoreSearchState => {
  const mainEntity = currentSourceConfig?.entity ?? DefaultMainEntity;
  const defaultTypes = {
    includeHachetteWorks,
    selectedMainEntity: mainEntity,
    selectedSubEntity: getDefaultSubEntity(mainEntity, currentSourceConfig),
  } as const;

  if (!currentSourceValue || currentSourceValue.linkStatus === 'empty') {
    return {
      ...defaultState,
      ...defaultTypes,
    };
  }

  switch (currentSourceValue.linkStatus) {
    case 'unnamed': {
      assert(false, 'makeInitialSearchState: unnamed link not supported');
      break;
    }
    case 'unverified': {
      return {
        state: EntitySearchState.search,
        searchQuery: getSearchString(currentSourceValue) ?? '',
        ...defaultTypes,
      };
    }
    case 'verified': {
      return currentSourceConfig?.initialState === EntitySearchState.search
        ? {
            state: EntitySearchState.search,
            searchQuery: isVerifiedLinkedCatalogPostLink(currentSourceValue)
              ? currentSourceValue.name
              : '',
            ...defaultTypes,
          }
        : {
            ...defaultState,
            ...defaultTypes,
            state: EntitySearchState.viewEntity,
            viewEntity: {
              id: assert(
                currentSourceValue.entityId,
                'useEntitySearchContextProviderValue: entityId expected',
                currentSourceValue,
              ),
            },
          };
    }
  }
};
